import type { Lang } from "@kit/lang";

export const STRINGS = {
  name: { tr: "Başkent Eşle", en: "Capital Match" },
  back: { tr: "‹ Oyunlar", en: "‹ Games" },
  level: { tr: "SEVİYE", en: "LEVEL" },
  moves: { tr: "Hamle", en: "Moves" },
  target: { tr: "hedef", en: "target" },
  instruction: { tr: "Ülke ve başkentini eşleştir.", en: "Match each country with its capital." },
  country: { tr: "ÜLKE", en: "COUNTRY" },
  capital: { tr: "BAŞKENT", en: "CAPITAL" },
  matched: { tr: "EŞLEŞTİ", en: "MATCHED" },
  restart: { tr: "Yeniden dağıt", en: "New deal" },
  share: { tr: "Paylaş", en: "Share" },
  skip: { tr: "Atla", en: "Skip" },
  winTitle: { tr: "Tebrikler!", en: "Well matched!" },
  winSubtitle: { tr: "{moves} hamlede eşleştirdin {stars}", en: "Matched in {moves} moves · {stars}" },
  next: { tr: "Sonraki seviye", en: "Next level" },
  shareTitle: { tr: "Başkent Eşle — Enjoyment", en: "Capital Match — Enjoyment" },
  shareScore: { tr: "Başkent Eşle: bu bölümü {moves} hamlede eşleştirdim!", en: "Capital Match: I matched this level in {moves} moves!" },
  countryKnown: { tr: "Ülke", en: "Country" },
} satisfies Record<string, { tr: string; en: string }>;

export function t(lang: Lang, key: keyof typeof STRINGS): string {
  return STRINGS[key][lang];
}
